<template>
  <section class="section-content address">
    <div class="header" style="background-color: transparent"></div>
    <b-container class="mb-4">
      <b-row>

        <b-col lg="3">
          <b-form v-if="name" style="border-color: #4A4CB0; color: #ffffff; background-color: #4A4CB0; font-size: 25px; border-radius: calc(6px - 1px); box-shadow: 0 5px 20px 0 rgb(218 222 229 / 80%)" class="mb-3 text-center" show><b>{{ name }}</b>
          </b-form>
          <template v-if="delay">
            <b-card class="mb-4" no-body>
              <b-skeleton-img height="265px"/>
            </b-card>
          </template>
          <template v-else>
            <template v-if="image">
              <b-img class="w-100 mb-4" :width="300" :src="image" style="border-radius: 6px; box-shadow: 0 5px 20px 0 rgb(218 222 229 / 70%)"/>
            </template>
            <template v-else>
              <vue-qrcode class="w-100 mb-4" :width="300" :mask-pattern="7" :margin="0" :color="{dark: '#33262d'}" style="border-radius: 6px;" :value="'https://www.evrice.com/address/' + $route.params.id"/>
            </template>
          </template>
          <template>
            <b-button class="w-100 mb-4" variant="info" @click="getClipboard" style="box-shadow: 0 5px 20px 0 rgb(218 222 229 / 58%); border-color: transparent">
              <a style="font-size: 18px">{{ $t('index.ln3') }}</a>
            </b-button>
          </template>
          <template v-if="delay">
            <b-skeleton v-if="owner" class="mb-4" width="100%" type="button"/>
          </template>
          <template v-else>
            <b-button v-if="owner" :to="{ path: '/account'}" class="w-100 mb-4" variant="info" style="box-shadow: 0 5px 20px 0 rgb(218 222 229 / 58%); border-color: transparent">
              <i class="far fa-cog"/> {{ $t('address.ln_5') }}
            </b-button>
          </template>
          <span v-if="status && logget">
						<template v-if="delay">
							<b-skeleton v-if="!owner" class="mb-2" width="100%" type="button"/>
							<b-skeleton v-if="!owner" class="mb-4" width="100%" type="button"/>
						</template>
						<template v-else>
              <b-button v-if="!owner" @click="setMessage()" :class="'w-100 ' + (contract ? 'mb-4' : 'mb-2')" variant="success"><i class="fal fa-comment-alt-check"/> {{ $t('address.ln_12') }}</b-button>
							<template v-if="!contract">
								<template v-if="!owner && contact.staus">
									<b-overlay :show="contact.loading" opacity="0.6" spinner-small spinner-variant="info" class="d-inline-block w-100 mb-4">
										<b-button @click="deleteContact()" class="w-100" variant="info"><i class="fal fa-minus-circle animate-flicker"/> {{ $t('address.ln_7') }}</b-button>
									</b-overlay>
								</template>
								<template v-else-if="!owner">
									<b-overlay :show="contact.loading" opacity="0.6" spinner-small spinner-variant="info" class="d-inline-block w-100 mb-4">
										<b-button @click="setContact()" class="w-100" variant="info"><i class="far fa-plus-circle"/> {{ $t('address.ln_6') }}</b-button>
									</b-overlay>
								</template>
							</template>
						</template>
					</span>
          <b-card v-if="about" class="text-center card-bg mb-4">
            <template v-if="delay">
              <div class="mb-3" style="border-bottom: 1px solid #eceaea;">
                <b-skeleton class="mb-3" type="button" style="margin: 0 auto;"/>
              </div>
              <b-card-text>
                <b-skeleton width="100%"/>
                <b-skeleton width="80%"/>
                <b-skeleton width="100%"/>
                <b-skeleton width="70%"/>
                <b-skeleton width="100%"/>
              </b-card-text>
            </template>
            <template v-else>
              <div class="mb-3" style="border-bottom: 1px solid #eceaea;">
                <i style="font-size: 30px;color: #666;" class="fal fa-info-circle mb-3"/>
              </div>
              <b-card-text>
                <p class="mb-0">{{ about }}</p>
              </b-card-text>
            </template>
          </b-card>
          <b-card class="text-center card-bg mb-4">
            <template v-if="delay">
              <div class="mb-3" style="border-bottom: 1px solid #eceaea;">
                <b-skeleton class="mb-3" type="button" style="margin: 0 auto;"/>
              </div>
              <b-card-text>
                <b-skeleton width="100%"/>
                <b-skeleton width="100%"/>
              </b-card-text>
            </template>

            <template v-else>
              <div class="mb-3" style="border-bottom: 1px solid #eceaea;">
                <i style="font-size: 25px;color: #666;" class="fal fa-coins mb-3"/>
              </div>
              <b-card-text v-if="contract">
                <b v-if="name">

                </b>{{ total_supply | numberFormat }} {{ symbol }} <small class="text-muted">
                <div><b>{{ balance }} EVC</b></div>
              </small>
              </b-card-text>
              <b-card-text v-else>
                <b v-if="name">

                </b><b>{{ balance }} EVC</b>
              </b-card-text>
            </template>
          </b-card>
          <b-card v-if="tokens.length > 0" class="token-list card-bg mb-4 overflow-auto">
            <b-media no-body v-for="(item, index) in tokens" :key="index" >
              <b-media-aside>
                <b-avatar variant="default" :text="item.name ? $options.filters['namegr'] (item.name) : ''" size="3rem"/>
              </b-media-aside>
              <b-media-body>
                <div class="mt-0"><b>{{ item.value ? item.value.toFixed(0) : "0.00000000" }} </b>
                  <b>{{ item.symbol }}</b></div>
                <p :class="tokens.length-1 === index ? 'mb-0' : ''">
                  <small class="text-muted">{{ item.name }}</small>
                </p>
              </b-media-body>
            </b-media>
          </b-card>
          <b-card v-if="contact.count" class="card-bg mb-4">
            <div class="text-center mb-3" style="border-bottom: 1px solid #eceaea;">
              <template v-if="contact.delay">
                <b-skeleton type="button" style="margin: 0 auto 20px auto;"/>
              </template>
              <template v-else>
                <b-link :to="{ path: '/contacts/' + address + '/main'}">
                  <i style="font-size: 30px;color: #666;" class="fal fa-address-book mb-3"/>
                </b-link>
              </template>
            </div>
            <b-card-text class="contact">
              <b-link class="item" v-for="item in contact.items" :key="item.id" :to="{ path: '/address/' + item.address}">
                <template v-if="contact.delay">
                  <b-skeleton style="margin: 0 auto;" class="mb-2" width="50px" height="50px" type="avatar"/>
                  <b-skeleton style="margin: 0 auto;" width="90%"/>
                </template>
                <template v-else>
                  <b-avatar v-b-tooltip.hover :title="item.name ? item.name : item.address" variant="default" :src="item.image" :text="item.name | namegr" size="3rem"/>
                  <span class="name" :to="{ path: '/address/' + item.address}">{{ item.name ? item.name : item.address }}</span>
                </template>
              </b-link>
            </b-card-text>
          </b-card>
        </b-col>

        <b-col lg="9">
          <b-row v-if="!contract">
            <b-col lg="4">
              <template v-if="delay">
                <b-card class="text-center mb-4">
                  <b-card-text>
                    <b-skeleton type="button" style="margin: 0 auto;"/>
                  </b-card-text>
                  <template v-slot:footer>
                    <b-skeleton width="100%"/>
                  </template>
                </b-card>
              </template>
              <template v-else>
                <b-card class="text-center mb-4" id="target-account-type">
                  <b-card-text>
                    <span class="fs-25"><i v-if="contract" class="fal fa-file-contract"/><i v-else class="fal fa-id-card"/></span>
                  </b-card-text>
                  <template v-slot:footer>
                    <span class="fs-18">{{ $t('address.ln_16') }}</span>
                  </template>
                  <b-tooltip target="target-account-type" triggers="hover">
                    {{ contract ? $t('address.ln_18') : $t('address.ln_17') }}
                  </b-tooltip>
                </b-card>
              </template>
            </b-col>
            <b-col lg="4">
              <b-link :to="{ path: '/contacts/' + address + '/main' }">
                <template v-if="delay">
                  <b-card class="text-center mb-4">
                    <b-card-text>
                      <b-skeleton type="button" style="margin: 0 auto;"/>
                    </b-card-text>
                    <template v-slot:footer>
                      <b-skeleton width="100%"/>
                    </template>
                  </b-card>
                </template>
                <template v-else>
                  <b-card class="text-center mb-4">
                    <b-card-text>
                      <span class="fs-25">{{ contact.count }}</span>
                    </b-card-text>
                    <template v-slot:footer>
                      <span class="fs-18">{{ $t('address.ln_8') }}</span>
                    </template>
                  </b-card>
                </template>
              </b-link>
            </b-col>
            <b-col lg="4">
              <b-link v-b-modal.modal-specification>
                <template v-if="delay">
                  <b-card class="text-center mb-4">
                    <b-card-text>
                      <b-skeleton type="button" style="margin: 0 auto;"/>
                    </b-card-text>
                    <template v-slot:footer>
                      <b-skeleton width="100%"/>
                    </template>
                  </b-card>
                </template>
                <template v-else>
                  <b-card class="text-center mb-4">
                    <b-card-text>
                      <span class="fs-25">{{ specification.length }}</span>
                    </b-card-text>
                    <template v-slot:footer>
                      <span class="fs-18">{{ $t('address.ln_9') }}</span>
                    </template>
                  </b-card>
                </template>
              </b-link>
              <b-modal id="modal-specification" centered :title="$t('address.ln_9')" hide-footer>
                <template v-if="specification.length > 0">
                  <b-list-group>
                    <b-list-group-item v-for="item in specification" :key="item.id">
                      <i class="fas fa-arrow-alt-circle-right"/> {{ item.label }}
                    </b-list-group-item>
                  </b-list-group>
                </template>
                <template v-else>
                  <div class="text-center">
                    <i class="fal fa-grin-wink display-4"/>
                  </div>
                </template>
              </b-modal>
            </b-col>
            <!--  Виджет спецификаций
            <b-col lg="3">
              <b-link :to="{ path: '/articles?address=' + address}">
                <template v-if="delay">
                  <b-card class="text-center mb-4">
                    <b-card-text>
                      <b-skeleton type="button" style="margin: 0 auto;"/>
                    </b-card-text>
                    <template v-slot:footer>
                      <b-skeleton width="100%"/>
                    </template>
                  </b-card>
                </template>
                <template v-else>
                  <b-card class="text-center mb-4">
                    <b-card-text>
                      <span class="fs-25">{{ article.count > 3 ? article.count - 0 : article.count }}{{ article.count > 3 ? "" : "" }}</span>
                    </b-card-text>
                    <template v-slot:footer>
                      <span class="fs-18">{{ $t('address.ln_14') }}</span>
                    </template>
                  </b-card>
                </template>
              </b-link>
            </b-col>
            -->
          </b-row>
          <b-alert :show="!status"><i class="fal fa-shield"/> {{ $t('address.ln_4') }}</b-alert>



          <b-tabs content-class="mt-1" active-nav-item-class="tabs-address-active" nav-wrapper-class="tabs-address-wrapper" nav-class="tabs-address" justified>

            <!-- публикации -->
            <b-tab>
              <template slot="title">
                <i class="fal fa-comment-edit"/> {{ $t('address.ln_20') }}
                <b v-if="article.count">({{ article.count }})</b>
              </template>
              <hr>
              <template>
              <b-button style="box-shadow: 0 5px 20px 0 rgb(218 222 229 / 60%); border-color: transparent" v-if="owner" :to="{ path: '/articles/editor/0'}" class="w-100 mb-4" variant="info">
                <i class="fal fa-edit"/> {{ $t('article.ln_10') }}
              </b-button>
              </template>

              <b-card no-body class="mb-4" v-for="item in article.items" :key="item.id" header-bg-variant="white" style="border-radius: 5px">
                      <b-list-group horizontal="md" style="border-radius: 5px">
                      <b-list-group-item style="border-color: transparent; border-radius: 5px">
                      <b-media-aside vertical-align="center" style="display: block; margin: auto; text-align: center; border-radius: 5px">
                        <b-avatar class="mr-1" style="border-radius: 5px" variant="default" :text="item.name | namegr" :src="item.image" size="11rem" rounded/>
                      </b-media-aside>
                      </b-list-group-item>
                      <b-list-group-item style="border-color: transparent">
                      <b-media-body>

                        <!-- ссылка на всплавающее окно - <b-link v-b-modal.modal-article :key="+item.id">              ссылка на оригинал <b-link :to="{ path: '/article/' + item.id}">  -->
                        <b-link :to="{ path: '/article/' + item.id}" >
                          <b-list-group >
                            <b-list-group-item style="background: transparent; border-color: transparent; padding-top: 0px">
                              <b class="float-left">{{ item.name.slice(0, 100) }}</b>
                            </b-list-group-item>
                            <b-list-group-item style="background: transparent; border-color: transparent;">{{ item.text }}...</b-list-group-item>
                            <b-list-group-item style="background: transparent; border-color: transparent; padding-bottom: 0px">
                              <small class="text-muted">
									<span class="float-left">
										<i class="fal fa-clock"/> <time-ago :refresh="1" long :locale="$i18n.locale" :datetime="item.timestamp * 1000" :tooltip="true"/>
									</span>
                                <template>
										<span class="float-right">
											<i class="fal fa-code-commit"/> {{$t('article.ln_11')}}: <b>{{ item.post_count !== undefined ? item.post_count : 0 }}</b>
										</span>
                                </template>
                              </small>
                            </b-list-group-item>
                          </b-list-group>
                        </b-link>
                      </b-media-body>
                      </b-list-group-item>
                      </b-list-group>



              </b-card>
              <b-button v-if="article.more.show" @click="getMoreArticle" class="mb-4 w-100" variant="light">
                <b-spinner v-if="article.more.loading" small/>
                <i v-else class="fas fa-angle-down text-info"></i>
              </b-button>
              <template v-if="article.count === 0">
                <div class="text-center my-5 py-5">
                  <i class="mb-4 display-4 fal fa-comment-alt-edit"/>
                  <h3>{{ $t('address.ln_21') }}</h3>
                </div>
              </template>
            </b-tab>

            <!-- сообщения -->
            <b-tab>
              <template slot="title">
                <i class="fal fa-comment-alt-lines" /> {{ $t('address.ln_11') }}
                <b v-if="$store.state.message.count">({{ $store.state.message.count }})</b>
              </template>
              <hr>
              <message scope-type="message-address" :scope-address="address" :scope-parent="0"/>
            </b-tab>

            <!-- транзакции -->
            <b-tab >
              <template slot="title" >
                <i class="fal fa-comment-alt-dollar"/> {{ $t('address.ln_3') }}
                <b v-if="transaction.count">({{ transaction.count }})</b>
              </template>
              <hr>
              <template v-if="transaction.items.length > 0">

                <b-card class="message-item mb-4" v-for="item in transaction.items" :key="item.id">
                  <template v-if="transaction.delay">
                    <template slot="header" >
                      <b-skeleton width="60%"/>
                    </template>
                    <b-row class="text-center">
                      <b-col lg="5">
                        <b-skeleton width="100%"/>
                      </b-col>
                      <b-col lg="2">
                        <b-skeleton width="100%"/>
                      </b-col>
                      <b-col lg="5">
                        <b-skeleton width="100%"/>
                      </b-col>
                    </b-row>
                    <template slot="footer">
                      <b-skeleton width="20%"/>
                    </template>
                  </template>

                  <b-list-group>
                    <b-list-group-item style="padding-block: 3px; border-color: transparent">
                      <i class="far fa-coins"/> <span class="text-secondary"><b>{{ item.value }}</b></span> <b>{{ item.contract ? item.symbol : 'EVC' }}</b> <b-badge class="text-muted" variant="light"><small class="text-muted" style="font-size: 12px">{{ $t('explorer.ln_41') }}: <span>{{ item.fee.slice(0,8) }}</span> EVC</small></b-badge><b-badge v-if="item.deploy" variant="primary">DC</b-badge>
                    </b-list-group-item>
                    <b-list-group-item style="padding-block: 3px; border-color: transparent; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
                      <template v-if="item.check_nonce && item.status > 0">
                        <i class="fas fa-check-circle mr-2"/>
                      </template>
                      <template v-else>
                        <i class="fas fa-do-not-enter mr-2"/>
                      </template>
                      <router-link v-b-tooltip.hover :title="item.hash" class="text-space" :to="{ path: '/explorer/tx/'+ item.hash}">
                        <b><i class="fas fa-hashtag"/> {{ item.hash}}</b></router-link>
                    </b-list-group-item>
                    <b-list-group-item style="padding-block: 3px; border-color: transparent">
                      <i class="fal fa-clock"/> <time-ago :refresh="1" long :locale="$i18n.locale" :datetime="item.timestamp * 1000" :tooltip="true"/>
                    </b-list-group-item>
                    <b-list-group-item style="padding-block: 3px; border-color: transparent">
                      <b-row class="text-center">
                        <b-col lg="3" >
                          <widget class="mt-4" style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis"  :scope-address="item.from" scope-template="transfer-user"/>
                        </b-col>
                        <b-col lg="1">
                          <i class="far fa-arrow-circle-right text-danger fs-25 my-5"/>
                        </b-col>
                        <b-col lg="4">
                          <template v-if="item.contract">
                            <widget class="mt-4" :scope-address="item.contract" scope-template="transfer-user"/>
                          </template>
                          <template v-else>
                            <i class="fas fa-file-signature my-5" style="font-size:30px;"></i>
                          </template>
                        </b-col>
                        <b-col lg="1">
                          <i class="far fa-arrow-circle-right text-success fs-25 my-5"/>
                        </b-col>
                        <b-col lg="3" >
                          <widget class="mt-4" style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis"  :scope-address="item.to" scope-template="transfer-user"/>
                        </b-col>
                      </b-row>
                    </b-list-group-item>
                  </b-list-group>

                </b-card>
                <b-button v-if="transaction.more.show" @click="getMore" class="mb-4 w-100" variant="light">
                  <b-spinner v-if="transaction.more.loading" small/>
                  <i v-else class="fas fa-angle-down text-info"></i>
                </b-button>
              </template>
              <template v-else >
                <template v-if="transaction.delay">
                  <div class="my-5 py-5">
                    <b-skeleton style="margin: 0 auto 10px;" type="avatar"/>
                    <b-skeleton style="margin: 0 auto 10px;" width="50%"/>
                    <b-skeleton style="margin: 0 auto;" width="80%"/>
                  </div>
                </template>
                <template v-else>
                  <div class="text-center my-5 py-5">
                    <i class="mb-4 display-4 fal fa-coins"/>
                    <h3>{{ $t('address.ln_15') }}</h3>
                  </div>
                </template>
              </template>
            </b-tab>

          </b-tabs>
         </b-col>

      </b-row>
    </b-container>
    <!-- Попытка модального окна
    <b-modal class="v-b-modal.modal-tall" size="lg" id="modal-article" :title="$t( name )" centered hide-footer>
      <b-card v-for="item in article.items" :key="item.id" class="mb-3" style="border-color: transparent; background-color: transparent; box-shadow: none">
              <b-row>
                <b-col lg="3">
                  <b-avatar class="mr-1" style="border-radius: 5px" variant="default" :text="item.name | namegr" :src="item.image" size="11rem" rounded/>
                </b-col>
                <b-col lg="9">
                  <template>
                    <h3 class="name"><b>{{ item.name }}</b></h3>
                    <vue-markdown v-highlight :toc="true" class="markdown-body">{{ item.text }}</vue-markdown>
                    <b-row no-gutters>
                    </b-row>
                    <span class="tleft float-left">
              <i class="fal fa-clock"/> <time-ago :refresh="1" long :locale="$i18n.locale" :datetime="item.timestamp * 1000" :tooltip="true"/>
            </span>
                    <span class="tright float-right" v-if="owner">
              <b-link :to="{ path: '/articles/editor/' + id}"><i class="fal fa-pen-square text-secondary"/></b-link>
            </span>
                  </template>

                </b-col>
              </b-row>
          <message class="mt-4" v-if="item.post" scope-type="message-article" :scope-address="item.address" :scope-parent="Number(item.id)"/>

      </b-card>
    </b-modal>
    -->


  </section>
</template>

<script>

  import Vue from 'vue'
  import api from '../libs/api';
  import axios from 'axios';
  import VueQrcode from 'vue-qrcode';
  import Message from '../components/Message';
  import Widget from '../components/Widget';
  import TimeAgo from 'vue2-timeago';
  import VueClipboard from 'vue-clipboard2';

  import 'mavon-editor/dist/highlightjs/styles/github.min.css';
  import 'mavon-editor/dist/markdown/github-markdown.min.css';

  Vue.use(VueClipboard);

  export default {
    name: 'address.main',
    components: {
      VueQrcode,
      Message,
      TimeAgo,
      Widget
    },
    data() {
      return {
        name: null,
        image: null,
        about: null,
        balance: 0,
        status: false,
        contract: false,
        contract_owner: null,
        total_supply: 0,
        symbol: null,
        address: this.$route.params.id,
        owner: false,
        logget: false,
        tokens: [],
        contact: {
          item: {
            id: null,
            address: null,
            name: null,
            image: null
          },
          items: [],
          staus: false,
          delay: false,
          loading: false,
          count: 0
        },
        article: {
          items: [],
          delay: false,
          count: 0,
          text: null,
          post: false,
          more: {
            show: false,
            loading: false
          },
        },
        channel: {
          text: null,
          message: {
            id: null,
            inbox: null,
            text: null,
            name: null,
            address: null,
            timestamp: null,
            type: null,
            sub: null
          }
        },
        transaction: {
          item: {
            id: null,
            hash: null,
            value: null,
            contract: null,
            from: null,
            to: null,
            fee: 0,
            deploy: false,
            check_nonce: true,
            timestamp: 0,
            symbol: null,
            status: 0
          },
          more: {
            show: false,
            loading: false
          },
          items: [],
          count: 0,
          delay: false
        },
        specification: [],
        delay: false,
        post: false,

      }
    },
    metaInfo() {
      return {
        title: this.$data.name + ' ' + this.$data.address
      }
    },
    watch: {
      $route(scope) {
        this.$data.address = scope.params.id;
        this.getAccount(scope.params.id);
        this.getArticle(0);
      }
    },
    mounted() {
      this.$store.dispatch('getLocalStorageObject', 'account').then((account) => {
        this.$data.logget = !!account;
      });
      this.getArticle(0);
    },
    created() {
      this.getAccount(this.$data.address);
    },
    methods: {
      setMessage() {
        const element = this.$createElement
        this.$bvModal.msgBoxOk([element('textarea', {
          class: ['form-control'],
          props: {value: this.channel.text},
          on: {
            input: event => {
              this.channel.text = event.target.value
            }
          }
        })], {
          title: this.$t('address.ln_13'),
          size: 'md',
          buttonSize: 'md',
          okVariant: 'success',
          okTitle: this.$t('address.ln_12'),
          footerClass: 'p-2',
          centered: true
        }).then(() => {
          if (this.channel.text) {
            axios.post(api.inbox.messagePrivateSend, {
              text: this.channel.text,
              address: this.address
            }).then((response) => {

              this.channel.message.id = String(response.data.source[0].id);
              this.channel.message.inbox = String(response.data.source[0].inbox);
              this.channel.message.text = response.data.source[0].text;
              this.channel.message.name = response.data.source[0].name;
              this.channel.message.address = response.data.source[0].address;
              this.channel.message.timestamp = String(response.data.source[0].timestamp);
              this.channel.message.type = "inbox";
              this.channel.message.sub = "message";

              this.$socket.sendObj({
                type: "emit",
                channel: this.contract ? this.contract_owner : this.address,
                data: this.channel.message
              });

              this.$toast(`${this.$t('success.ln_5')}`, {
                type: "success"  // or "success", "error", "default", "info" and "warning"
              });

            }).catch((error) => {
              this.$toast(`${error.response.data.code}: ${error.response.data.message}`, {
                type: "error"  // or "success", "error", "default", "info" and "warning"
              });
            });
          } else {
            this.$toast(`${this.$t('error.ln_13')}`, {
              type: "error"  // or "success", "error", "default", "info" and "warning"
            });
          }
        }).catch((error) => {
          this.$toast(`${error.response.data.code}: ${error.response.data.message}`, {
            type: "error"  // or "success", "error", "default", "info" and "warning"
          });
        });
      },
      onCopy() {
        this.$bvToast.toast(`${this.$t('success.ln_5')}`, {
          title: this.$t('success.ln_3'),
          autoHideDelay: 2500,
          toaster: 'b-toaster-bottom-right',
          variant: 'info',
        });
      },
      setContact() {
        this.$data.contact.loading = true;
        axios.post(api.contact.set, {address: this.$data.address}).then((response) => {

          this.$data.contact.staus = response.data.success;
          this.$data.contact.loading = false;

        }).catch((error) => {
          this.$bvToast.toast(`${error.response.data.code}: ${error.response.data.message}`, {
            title: this.$t('error.ln_5'),
            autoHideDelay: 5000,
            toaster: 'b-toaster-bottom-right',
            variant: 'danger',
          });
        });
      },
      deleteContact() {
        this.$data.contact.loading = true;

        axios.post(api.contact.delete, {address: this.$data.address}).then(() => {
          this.$data.contact.staus = false;
          this.$data.contact.loading = false;
        }).catch((error) => {
          this.$bvToast.toast(`${error.response.data.code}: ${error.response.data.message}`, {
            title: this.$t('error.ln_5'),
            autoHideDelay: 5000,
            toaster: 'b-toaster-bottom-right',
            variant: 'danger',
          });
        });
      },
      checkContact() {
        axios.post(api.contact.check, {address: this.$data.address}).then((response) => {
          this.$data.contact.staus = response.data.success;
        });
      },
      getContact(transposal) {
        this.$data.contact.delay = true;
        axios.post(api.contact.get, {
          address: this.$data.address,
          transposal: transposal,
          limit: 6
        }).then(async (response) => {
          this.$data.contact.items = [];
          if (response.data.source !== undefined) {
            this.$data.contact.count = response.data.count;
            for (let i = 0; i < response.data.source.length; i++) {

              await this.$storage("account", response.data.source[i].address, response.data.source[i].image).then((image) => {
                this.$data.contact.item.image = image;
              });

              this.$data.contact.item.id = response.data.source[i].id
              this.$data.contact.item.address = response.data.source[i].address
              this.$data.contact.item.name = response.data.source[i].name

              this.$data.contact.items.push(Object.assign({}, this.$data.contact.item));
            }
          } else {
            this.$data.contact.count = 0;
          }
          this.$data.contact.delay = false;
        });
      },
      getArticle(last) {
        if (last) {
          this.$data.article.more.loading = true;
        } else {
          this.$data.article.delay = true;
        }

        axios.post(api.article.list, {last: last, limit: 5, address: this.$data.address}).then (async (response) => {
          if (!last) {
            this.$data.article.items = [];
          }

          if (response.data.source !== undefined) {
            this.$data.article.count = response.data.count;
            for (let i = 0; i < response.data.source.length; i++) {

              await this.$storage("article", response.data.source[i].address, response.data.source[i].image).then((image) => {
                response.data.source[i].image = image;
              });
              this.article.name = response.data.source[0].name;
              this.article.text = response.data.source[0].text;
              this.article.address = response.data.source[0].address;
              this.article.post = response.data.source[0].post;
              this.article.author = response.data.source[0].author;

              this.$data.article.items.push(Object.assign({}, response.data.source[i]));
            }
            this.$data.article.more.show = this.$data.article.count > this.$data.article.items.length;
          } else {
            this.$data.article.more.show = false;
            this.$data.article.count = 0;
          } if (last) {
            this.$data.article.more.loading = false;
          }
          this.$data.article.delay = false;
        });
      },




      getAccount(address) {
        this.$data.delay = true;

        this.$store.dispatch('getLocalStorageObject', 'account').then((account) => {
          if (account) {
            this.$data.owner = account.address === this.$data.address;
            this.$data.logget = true;
          }
        });

        if (this.$web3.utils.isAddress(address) && this.$web3.utils.checkAddressChecksum(this.$web3.utils.toChecksumAddress(address))) {
          axios.post(api.account.info, {address: address}).then(async (response) => {

            this.$data.specification = [];
            this.$data.tokens = [];

            this.$data.status = !!response.data.status;
            this.$data.name = (response.data.name ? response.data.name : "");
            this.$data.about = (response.data.about ? response.data.about : "");
            this.$data.balance = (response.data.value ? response.data.value : 0);
            this.$data.symbol = (response.data.symbol ? response.data.symbol : "Unknown");
            this.$data.contract = response.data.contract;
            this.$data.contract_owner = response.data.contract_owner;
            this.$data.total_supply = (response.data.total_supply ? response.data.total_supply : 0);
            this.$data.tokens = (response.data.tokens ? response.data.tokens : []);

            await this.$storage("account", response.data.address, response.data.image).then((response) => {
              this.$data.image = response;
            });

            let index = this.$t('account.specification');
            for (let i = 0; i < response.data.specification.length; i++) {
              if (index[response.data.specification[i]].id !== 0) {
                this.$data.specification.push({
                  id: index[response.data.specification[i]].id,
                  label: index[response.data.specification[i]].label
                })
              }
            }

            // Init method.
            if (this.$data.logget) {
              await this.checkContact();
            }
            await this.getContact(true);
            await this.getArticle();
            await this.getTransaction(0, response.data.address);

            this._.delay(() => {
              this.$store.dispatch('getMessageCount').then((count) => {
                this.$store.state.message.count = count;
              });
            }, 1000);

            this.$data.delay = false;

          }).catch(() => {
            this.getBalance(address);
            this.getTransaction(0, address);

            this._.delay(() => {
              this.$store.dispatch('getMessageCount').then((count) => {
                this.$store.state.message.count = count;
              });
            }, 1000);

            this.$data.contact.items = [];
            this.$data.contact.count = 0;
            this.$data.article.items = [];
            this.$data.article.count = 0;
            this.$data.specification = [];
            this.$data.tokens = [];
            this.$data.image = null;
            this.$data.name = null;
            this.$data.about = null;
            this.$data.status = false;
            this.$data.logget = false;
            this.$data.delay = false;
          });

        } else {
          this.$router.push('/error/1');
        }
      },
      getBalance(address) {
        this.$web3.eth.getBalance(address).then((balance) => {
          this.$data.balance = Number(this.$web3.utils.fromWei(balance, 'ether')).toFixed(8);
        });
      },
      getMore() {
        this.getTransaction(this.$data.transaction.items[this.$data.transaction.items.length - 1].id, this.$data.address);
      },
      getMoreArticle() {
        this.getArticle(this.$data.article.items[this.$data.article.items.length - 1].id)
      },
      getTransaction(last, address) {

        if (last) {
          this.$data.transaction.more.loading = true;
        } else {
          this.$data.transaction.delay = true;
        }

        axios.post(api.explorer.getTransactions, {last: last, limit: 4, address: address}).then((response) => {

          if (!last) {
            this.$data.transaction.items = [];
          }

          if (response.data.source !== undefined) {
            this.$data.transaction.count = response.data.count;
            for (let i = 0; i < response.data.source.length; i++) {

              const BN = this.$web3.utils.BN;

              this.$data.transaction.item.id = response.data.source[i].id;
              this.$data.transaction.item.hash = response.data.source[i].tx;
              this.$data.transaction.item.value = response.data.source[i].value ? response.data.source[i].value : (response.data.source[i].token_value ? response.data.source[i].token_value : 0);
              this.$data.transaction.item.from = response.data.source[i].from;
              this.$data.transaction.item.to = response.data.source[i].to;
              this.$data.transaction.item.contract = response.data.source[i].contract;
              this.$data.transaction.item.deploy = response.data.source[i].deploy;
              this.$data.transaction.item.fee = this.$web3.utils.fromWei(new BN(response.data.source[i].gas_price * response.data.source[i].gas_limit).toString(), 'ether')
              this.$data.transaction.item.check_nonce = response.data.source[i].check_nonce;
              this.$data.transaction.item.timestamp = response.data.source[i].timestamp;
              this.$data.transaction.item.status = response.data.source[i].status;

              if (response.data.source[i].token !== undefined) {
                this.$data.transaction.item.symbol = response.data.source[i].token[0].symbol;
                this.$data.transaction.item.value = response.data.source[i].token[0].value ? response.data.source[i].token[0].value : 0;
              }

              this.$data.transaction.items.push(Object.assign({}, this.$data.transaction.item));

            }
            this.$data.transaction.more.show = this.$data.transaction.count > this.$data.transaction.items.length;
          } else {
            this.$data.transaction.count = 0;
            this.$data.transaction.more.show = false;
          }

          if (last) {
            this.$data.transaction.more.loading = false;
          }

          this.$data.transaction.delay = false;
        });
      },
      getClipboard() {
        const element = this.$createElement
        this.$bvModal.msgBoxOk([
        element('vue-qrcode', {
          props: {
            value: this.address,
            width: 400,
            margin: 0
          },
          style: {
            width: '100%'
          }
        }), element('div', {
            domProps: { innerHTML: `<h5><b>${this.address}</b></h5>` },
            style: {
              width: '100%',
              marginTop: '25px'
            }
          })], {
          title: this.$t('index.ln4') + ' ' + this.$data.name,
          okTitle: 'Copy address',
          size: 'md',
          centered: true
        }).then(() => {
          this.$copyText(this.address);
        });
      },
    }
  };

</script>

<style scoped>
.address .contact {
  position: relative;
}

.address .contact > .item {
  float: left;
  width: 75px;
  overflow: hidden;
  padding: 6px 0 5px;
  text-align: center;
}

.address .contact > .item:hover {
  border-radius: 3px;
  background-color: #e8e7f1;
}

.address .contact .name {
  margin: 0 5px;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.address .token-list {
  max-height: 213px;
}

.address .token-list::-webkit-scrollbar {
  width: 5px; /* for vertical scrollbars */
  height: 5px; /* for horizontal scrollbars */
}

.address .token-list::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 3px;
}

.address .token-list::-webkit-scrollbar-thumb {
  background: #5759BE ;
  border-radius: 3px;
}



</style>
